import { upperFirst } from 'lodash';
import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import lowerCase from 'lodash/lowerCase';
import startCase from 'lodash/startCase';

export const NEWLINE_REGEXP = /\r\n|\r|\n/;

export const UUID_V4_REGEX =
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

export const toCamelCase = (text: string): string => camelCase(text);

export const toKebabCase = (text: string): string => kebabCase(text);

export const pascalCase = (value: string): string =>
  startCase(value).replaceAll(' ', '');

export const getInitial = (string: string): string =>
  string
    .split(' ')
    .map((word: string) => word[0])
    .join('.');

export const splitByCapitalLetters = (str?: string): string => {
  return str ? str.split(/(?=[A-Z])/).join(' ') : '';
};

export const camelCaseToWords = (text: string): string => {
  if (!text) return text;

  return text
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // Handle acronyms like "EDD"
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .trim();
};

export const capitalizeFirstLetter = (str = ''): string => {
  if (!str) {
    return '';
  }

  const firstLetterCapitalized = str.charAt(0).toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCapitalized + remainingLetters;
};

export const buildFullName = (
  object: Record<string, unknown> | null | undefined
): string => {
  const fields = [
    'firstName',
    'lastName',
    'contactFirstName',
    'contactLastName'
  ];
  const temp = object ?? {};
  const results = fields.splice(
    fields.findIndex((name) => temp[name]),
    2
  );
  const firstName = temp[results[0]];
  const lastName = temp[results[1]];
  return [firstName, lastName].filter((s) => s).join(' ');
};

export const countLines = (str: string): number => {
  if (!str) {
    return 0;
  }
  return str.split(NEWLINE_REGEXP).length;
};

export const toLowerCase = (str: string): string => lowerCase(str);

export const compareStrings = (
  originalString: string,
  compareString: string
): boolean => {
  const regex = /[A-Za-z]+/g;

  const originalLetters =
    originalString.match(regex)?.join('').toLowerCase() || '';
  const compareLetters =
    compareString.match(regex)?.join('').toLowerCase() || '';

  return originalLetters === compareLetters;
};

export const snakeCaseToWords = (str: string): string => {
  if (!str) return '';
  return str.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
};

export const splitAndCapitalizeFirstWord = (str: string): string => {
  if (!str) {
    return '';
  }

  const words = startCase(str).split(' ');
  return upperFirst(words[0]) + ' ' + lowerCase(words.slice(1).join(' '));
};
